import {createEventDeepLink} from '../../utils/BranchService';

const createEventBranchDeepLink =  (event, deeplinkRowId) => {
   return {
      type: 'CREATE_EVENT_DEEP_LINK',
      payload: createEventDeepLink(event, deeplinkRowId),
   }
}

export default createEventBranchDeepLink;



// WEBPACK FOOTER //
// ./src/actions/events/createEventDeepLinkAction.js